import { UpdateNotificationsSettingsDto } from '@/common/api/datasources/Api';
import { useUserNotificationsSettingsQuery } from '@/common/api/services/userNotificationsSettings';
import { useToast } from "@/hooks/use-toast";
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useUserNotificationsSettings = () => {
    const { t } = useTranslation();
    const { toast } = useToast();
    const queryClient = useQueryClient();
    const { settingsQuery, updateSettingsMutation } = useUserNotificationsSettingsQuery();

    const { data: settings, isLoading , error} = useQuery(settingsQuery);

    const { mutate: updateSettings } = useMutation({
        ...updateSettingsMutation,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user-notifications-settings'] });
            toast({
                title: t('settings.update.success'),
                description: t('settings.notifications.update.success'),
            });
        },
        onError: (error) => {
            toast({
                variant: "destructive",
                title: t('settings.update.error'),
                description: t('settings.notifications.update.error'),
            });
        },
    });

    const handleNotificationsChange = (type: keyof UpdateNotificationsSettingsDto, value: boolean) => {
        updateSettings({ [type]: value });
    };

    return {
        settings,
        isLoading,
        error,
        handleNotificationsChange,
    };
}; 